<div id="main-content" class="wrapper has-padding margin-height zoom-margin" (focusout)="onFocusOutMainContent()">
  <form [formGroup]="politicalContributionGroup">

    <h1 class="bofa--heading is-4 double-bottom-space">Global Wealth & Investment Management</h1>

    <div class="bottom-space">
      <div class="label-space" id="contribution-radio-group-label"><abbr title="required">* </abbr>Have you made
        any political contributions within the last 24 months?
      </div>
      <mat-radio-group name="radioContribution" aria-labelledby="contribution-radio-group-label"
        formControlName="contribution" required (focusout)="radioOnBlur()" (focusin)="radioOnFocus()">
        <mat-radio-button class="minor-list-space radio-padding minor-radio-padding" value="1" name="contribution">Yes
        </mat-radio-button>
        <mat-radio-button class="minor-radio-padding" value="0" name="contribution">No</mat-radio-button>
      </mat-radio-group>
    </div>

    <mat-error class="padding-top" *ngIf="submit.value && contribution.hasError('required') || checkRadio">Please
      select if you Have you made any political contributions within the last 24 months</mat-error>

    <div *ngIf="politicalContributionGroup.controls.contribution.value == 1">
      <h2 class="bofa--heading is-7 has-text-centered"><strong>BANK OF AMERICA MERRILL LYNCH GLOBAL WEALTH &
          INVESTMENT MANAGEMENT<br aria-hidden="true" /> TRANSFER/PRE-EMPLOYMENT POLITICAL CONTRIBUTION
          CERTIFICATION</strong>
      </h2>

      <p>Various regulations, including Securities and Exchange Commission Rule 206(4)-5, as well as various U.S.
        state and local statutes, govern the activities of financial institutions and certain of their employees
        relative to Political Contributions. These rules can provide for firm-wide bans on entering into various
        categories of banking relationships or transactions with governmental entities if a Political
        Contribution
        in excess of de minimis amounts is made by a covered employee to a political candidate, political party
        committee, or political action committee. These include Political Contributions made before an
        individual
        becomes an employee of the financial institution.</p>

      <p>To ensure its compliance with such rules, Bank of America Merrill Lynch must request disclosure of
        certain
        information regarding Political Contributions that you may have made to political candidates within the
        U.S.
        (including at the federal, state, or local levels), as well as Political Contributions or payments that
        you
        may have made to political action committees or political parties, within the past two years.</p>

      <p>Please read the certification below, provide any details necessary to make the certification accurate,
        and
        sign and date the form. Thank you for your assistance. </p>

      <h3 class="bofa--heading is-7"><strong>Political Contributions Disclosure Form</strong></h3>

      <p><strong>Include contributions made to officials, political candidates, or political parties or political
          action committees ("PACs") in the last 24 months.</strong></p>

      <!-- set focus when save and continue error -->
      <div tabindex="-1" #missingElement class="bofa--skiplink"></div>

      <mat-tab-group animationDuration="0ms" [selectedIndex]="selected.value"
        (selectedIndexChange)="selected.setValue($event)" [class.border-red-tab]="redBorder">
        <mat-tab>
          <ng-template mat-tab-label>
            <div class="has-padding has-text-centered"
              matTooltip="Contributions to officials, political candidates, or to PACs or state/local political parties that were earmarked for a specific official or candidate"
              matTooltipPosition="below" matTooltipClass="bofa--heading is-9">
              <span *ngIf="pcCandidateList.invalid">
                <img src="assets/bofa_icon_alert.svg" class="review-icon-survey icon-pad"
                  alt="error incomplete contribution" role="img" />
              </span>
              <span *ngIf="pcCandidateList.length > 0 && !pcCandidateList.invalid">
                <img src="assets/bofa_icon_checkmark2.svg" class="review-icon-survey icon-pad"
                  alt="check completed contribution" role="img" />
              </span>
              Official or Candidate
            </div>
          </ng-template>

          <div class="double-bottom-space">
            <div class="flex-container">
              <div class="fx-flex-40">
                <h3 class="bofa--heading is-5">Contribution</h3>
              </div>
              <div class="fx-flex-60">
                <div *ngIf="pcCandidateList.length === 0" class="padding-top"> <button
                    [disabled]="pcCandidateList.invalid" type="button" class="bofa--button secondary" #addButtonElement
                    (click)="createCandidateContribution()">Add
                    Contribution</button>
                </div>
              </div>
            </div>

            <div>
              <ng-container *ngFor="let pcDetail of pcCandidateList.controls; let i = index" [formGroup]="pcDetail"
                class="double-bottom-space">
                <mat-card appearance="outlined"
                  class="af-mat-card mat-card-padding mat-elevation-z flex-change double-bottom-space"
                  [class.border]="blueBorder">

                  <!-- set focus when pressing Add button -->
                  <div *ngIf="pcDetail.invalid" tabindex="-1" #addElement class="bofa--skiplink">
                  </div>

                  <div class="item-display bottom-space">
                    <div class="label-padding max-width">
                      <label class="minor-label-padding" id="recipientLongLabel"><abbr title="required">*
                        </abbr>Recipient
                        of the contribution (candidate, officeholder)</label>
                      <mat-form-field class="width-450 max-width" hideRequiredMarker
                        aria-describedby="recipientLongLabel">
                        <input matInput formControlName="recipientName" required>
                        <mat-error>Please enter Name of Recipient</mat-error>
                      </mat-form-field>
                    </div>

                    <div class="label-padding max-width">
                      <label class="minor-label-padding" id="amountsLongLabel"><abbr title="required">* </abbr>Amount
                        (and form if other than cash or check/card)</label>
                      <mat-form-field class="width-350 max-width" hideRequiredMarker
                        aria-describedby="amountsLongLabel">
                        <input matInput formControlName="amount" required>
                        <mat-error>Amount (and form if other than cash, check, or card)</mat-error>
                      </mat-form-field>
                    </div>
                  </div>

                  <div class="item-display bottom-space">
                    <div class="bottom-space max-width">
                      <mat-form-field class="width-350 max-width" hideRequiredMarker>
                        <mat-label> <abbr title="required">* </abbr>Date of Contribution</mat-label>
                        <input matInput [matDatepicker]="contributionDatePicker" formControlName="contributionDate"
                          required>
                        <mat-datepicker-toggle matSuffix [for]="contributionDatePicker">
                        </mat-datepicker-toggle>
                        <mat-datepicker #contributionDatePicker></mat-datepicker>
                        <mat-error>Please enter Date of Contribution mm/dd/yyyy</mat-error>
                        <mat-hint>Format mm/dd/yyyy</mat-hint>
                      </mat-form-field>
                    </div>

                    <div class="label-padding max-width bottom-space">
                      <label class="minor-label-padding" id="typeLongLabel">Type of election (primary, general,
                        runoff, etc.)</label>
                      <mat-form-field class="width-450 max-width" aria-describedby="typeLongLabel">
                        <mat-select formControlName="contributionType" placeholder="Select">
                          <mat-option>Select</mat-option>
                          <mat-option
                            *ngFor="let electionType of pcSurveyData.pcElectionTypeLookup | keyvalue : valueAscOrder"
                            [value]=electionType.key>
                            {{electionType.value}}
                          </mat-option>
                        </mat-select>
                        <mat-hint class="bofa--skiplink">
                          <!-- Hidden for screen readers so it reads the current value selected from the dropdown -->
                          {{ dropDownScreenReaderElectionType(pcDetail) }}
                        </mat-hint>
                      </mat-form-field>
                    </div>
                  </div>

                  <div>
                    <label class="minor-label-padding" id="politicalLongLabel">Political office held by candidate at
                      time of contribution (if any)</label>
                    <mat-form-field class="width-550 max-width" aria-describedby="politicalLongLabel">
                      <mat-select formControlName="officeHeld" placeholder="Select">
                        <mat-option>Select</mat-option>
                        <mat-option *ngFor="let office of pcSurveyData.pcOfficeLookup | keyvalue : valueAscOrder"
                          [value]=office.key>
                          {{office.value}}
                        </mat-option>
                      </mat-select>
                      <mat-hint class="bofa--skiplink">
                        <!-- Hidden for screen readers so it reads the current value selected from the dropdown -->
                        {{ dropDownScreenReaderOffice(pcDetail) }}
                      </mat-hint>
                    </mat-form-field>
                  </div>

                  <div>
                    <label class="minor-label-padding" id="officeLongLabel">Office (mayor, governor, etc.) for which
                      candidate was running</label>
                    <mat-form-field class="width-550 max-width" aria-describedby="officeLongLabel">
                      <mat-select formControlName="officeRunning" placeholder="Select">
                        <mat-option>Select</mat-option>
                        <mat-option *ngFor="let office of pcSurveyData.pcOfficeLookup | keyvalue : valueAscOrder"
                          [value]=office.key>
                          {{office.value}}
                        </mat-option>
                      </mat-select>
                      <mat-hint class="bofa--skiplink">
                        <!-- Hidden for screen readers so it reads the current value selected from the dropdown -->
                        {{ dropDownScreenReaderRunning(pcDetail) }}
                      </mat-hint>
                    </mat-form-field>
                  </div>

                  <div>
                    <label class="minor-label-padding" id="nameLongLabel">Name of political subdivision (city, county,
                      state, federal, etc.)</label>
                    <mat-form-field class="width-550 max-width" aria-describedby="nameLongLabel">
                      <input matInput formControlName="subdivision">
                    </mat-form-field>

                    <div class="is-taller">
                      <button type="button" class="bofa--button primary outlined"
                        (click)="deleteCandidateContribution(i)">Remove this
                        Contribution</button>
                    </div>
                  </div>
                </mat-card>
              </ng-container>
            </div>
          </div>

          <!-- set based on tab -->
          <div *ngIf="pcCandidateList.length !== 0" class="double-bottom-space">
            <button [disabled]="pcCandidateList.invalid" type="button"
              class="bofa--button secondary marginright-marginleft-block"
              (click)="createCandidateContribution('click')">Add Contribution</button>
          </div>
        </mat-tab>

        <mat-tab>
          <ng-template mat-tab-label>
            <div class="has-padding has-text-centered"
              matTooltip="Contributions to state / local political parties or PACs" matTooltipPosition="below"
              matTooltipClass="bofa--heading is-9">
              <span *ngIf="pcLocalPartiesList.invalid">
                <img src="assets/bofa_icon_alert.svg" class="review-icon-survey icon-pad"
                  alt="error incomplete contribution" role="img" />
              </span>
              <span *ngIf="pcLocalPartiesList.length > 0 && !pcLocalPartiesList.invalid">
                <img src="assets/bofa_icon_checkmark2.svg" class="review-icon-survey icon-pad"
                  alt="check completed contribution" role="img" />
              </span>
              State or Local Parties
            </div>
          </ng-template>

          <div class="double-bottom-space">
            <div class="flex-container">
              <div class="fx-flex-40">
                <h3 class="bofa--heading is-5">Contribution</h3>
              </div>
              <div class="fx-flex-60">
                <div *ngIf="pcLocalPartiesList.length === 0" class="padding-top"> <button
                    [disabled]="pcLocalPartiesList.invalid" type="button" class="bofa--button secondary"
                    #addLocalButtonElement (click)="createLocalPartyContribution()">Add
                    Contribution</button>
                </div>
              </div>
            </div>

            <div>
              <ng-container *ngFor="let pcDetail of pcLocalPartiesList.controls; let i = index" [formGroup]="pcDetail"
                class="double-bottom-space">
                <mat-card appearance="outlined"
                  class="af-mat-card mat-elevation-z flex-change double-bottom-space mat-card-padding"
                  [class.border]="blueBorder">

                  <!-- set focus when pressing Add button -->
                  <div *ngIf="pcDetail.invalid" tabindex="-1" #addLocalElement class="bofa--skiplink">
                  </div>

                  <div class="item-display bottom-space">
                    <mat-form-field class="width-350" hideRequiredMarker>
                      <mat-label><abbr title="required">* </abbr>Name of recipient political party
                        or PAC</mat-label>
                      <input matInput formControlName="recipientName" required>
                      <mat-error>Please enter Name of Recipient political party
                        or PAC</mat-error>
                    </mat-form-field>

                    <div class="label-padding">
                      <label class="minor-label-padding" id="amountLongLabel"><abbr title="required">* </abbr>Amount
                        (and form if other than cash or check/card)</label>
                      <mat-form-field class="width-350" hideRequiredMarker aria-describedby="amountLongLabel">
                        <input matInput formControlName="amount" required>
                        <mat-error>Amount (and form if other than cash, check, or card)</mat-error>
                      </mat-form-field>
                    </div>
                  </div>

                  <div class="item-display">
                    <mat-form-field class="max-width width-350" hideRequiredMarker>
                      <mat-label> <abbr title="required">* </abbr>Date of Contribution</mat-label>
                      <input matInput [matDatepicker]="contributionDatePicker" formControlName="contributionDate"
                        required>
                      <mat-datepicker-toggle matSuffix [for]="contributionDatePicker">
                      </mat-datepicker-toggle>
                      <mat-datepicker #contributionDatePicker></mat-datepicker>
                      <mat-error>Please enter Date of Contribution mm/dd/yyyy</mat-error>
                      <mat-hint>Format mm/dd/yyyy</mat-hint>
                    </mat-form-field>

                    <div class="">
                      <button type="button" class="bofa--button primary outlined"
                        (click)="deleteLocalPartyContribution(i)">Remove this
                        Contribution</button>
                    </div>
                  </div>
                </mat-card>
              </ng-container>
            </div>
          </div>

          <!-- set based on tab -->
          <div *ngIf="pcLocalPartiesList.length !== 0" class="double-bottom-space">
            <button [disabled]="pcLocalPartiesList.invalid" type="button"
              class="bofa--button secondary marginright-marginleft-block"
              (click)="createLocalPartyContribution('click')">Add Contribution</button>
          </div>
        </mat-tab>

        <mat-tab>
          <ng-template mat-tab-label>
            <div class="has-padding has-text-centered"
              matTooltip="Name of any PAC that you control, and contributions made by the PAC to officials, political candidates, political parties or PACs"
              matTooltipPosition="below" matTooltipClass="bofa--heading is-9">
              <span *ngIf="pcPacsList.invalid">
                <img src="assets/bofa_icon_alert.svg" class="review-icon-survey icon-pad"
                  alt="error incomplete contribution" role="img" />
              </span>
              <span *ngIf="pcPacsList.length > 0 && !pcPacsList.invalid">
                <img src="assets/bofa_icon_checkmark2.svg" class="review-icon-survey icon-pad"
                  alt="check completed contribution" role="img" />
              </span>
              PACs
            </div>
          </ng-template>

          <div class="double-bottom-space">
            <div class="flex-container">
              <div class="fx-flex-40">
                <h3 class="bofa--heading is-5">Contribution</h3>
              </div>
              <div class="fx-flex-60">
                <div *ngIf="pcPacsList.length === 0" class="padding-top"> <button [disabled]="pcPacsList.invalid"
                    type="button" class="bofa--button secondary" #addPacsButtonElement
                    (click)="createPacsContribution()">Add
                    Contribution</button>
                </div>
              </div>
            </div>

            <div>
              <ng-container *ngFor="let pcDetail of pcPacsList.controls; let i = index" [formGroup]="pcDetail"
                class="double-bottom-space">
                <mat-card appearance="outlined"
                  class="af-mat-card mat-elevation-z flex-change double-bottom-space mat-card-padding"
                  [class.border]="blueBorder">

                  <!-- set focus when pressing Add button -->
                  <div *ngIf="pcDetail.invalid" tabindex="-1" #addPacsElement class="bofa--skiplink">
                  </div>

                  <div class="label-padding">
                    <label class="minor-label-padding width-600 max-width" id="pacNameLongLabel"><abbr
                        title="required">*
                      </abbr>Name of the PAC you control and the recipient official,
                      candidate, political party or PAC</label>
                    <mat-form-field class="width-600 max-width" hideRequiredMarker aria-describedby="pacNameLongLabel">
                      <input matInput formControlName="recipientName" required>
                      <mat-error>Please enter Name of Recipient official,
                        candidate, political party or PAC</mat-error>
                    </mat-form-field>
                  </div>

                  <div class="label-padding">
                    <label class="minor-label-padding width-450 max-width" id="amtNameLongLabel"><abbr
                        title="required">*
                      </abbr>Amount (and form if other than cash or check/card)</label>
                    <mat-form-field class="width-450 max-width" hideRequiredMarker aria-describedby="amtNameLongLabel">
                      <input matInput formControlName="amount" required>
                      <mat-error>Please enter Amount </mat-error>
                    </mat-form-field>
                  </div>

                  <div class="item-display">
                    <mat-form-field class="max-width width-350" hideRequiredMarker>
                      <mat-label> <abbr title="required">* </abbr>Date of Contribution</mat-label>
                      <input matInput [matDatepicker]="contributionDatePicker" formControlName="contributionDate"
                        required>
                      <mat-datepicker-toggle matSuffix [for]="contributionDatePicker">
                      </mat-datepicker-toggle>
                      <mat-datepicker #contributionDatePicker></mat-datepicker>
                      <mat-error>Please enter Date of Contribution mm/dd/yyyy</mat-error>
                      <mat-hint>Format mm/dd/yyyy</mat-hint>
                    </mat-form-field>

                    <div class="is-taller pad-left30">
                      <button type="button" class="bofa--button primary outlined"
                        (click)="deletePacsContribution(i)">Remove this
                        Contribution</button>
                    </div>
                  </div>
                </mat-card>
              </ng-container>
            </div>
          </div>

          <!-- set based on tab -->
          <div *ngIf="pcPacsList.length !== 0" class="double-bottom-space">
            <button [disabled]="pcPacsList.invalid" type="button"
              class="bofa--button secondary marginright-marginleft-block" (click)="createPacsContribution('click')">Add
              Contribution</button>
          </div>
        </mat-tab>
      </mat-tab-group>

      <mat-error *ngIf="checkContribution" class="is-taller">At least one contribution is required
      </mat-error>

      <div class="bottom-space">
        <div class="label-space" id="gwimVoteForCandidate-radio-group-label"><abbr title="required">* </abbr>If a
          contribution was to a candidate or party committee, were you entitled to vote for the candidate or in the
          jurisdiction covered by the party committee
        </div>
        <mat-radio-group name="radiogwimVoteForCandidate" aria-labelledby="gwimVoteForCandidate-radio-group-label"
          formControlName="gwimVoteForCandidate" required (focusout)="radioTwoOnBlur()" (focusin)="radioTwoOnFocus()">
          <mat-radio-button class="minor-list-space radio-padding minor-radio-padding" name="gwimVoteForCandidate"
            value="1">Yes
          </mat-radio-button>
          <mat-radio-button class="minor-list-space radio-padding minor-radio-padding" value="0"
            name="gwimVoteForCandidate">No
          </mat-radio-button>
          <mat-radio-button class="radio-padding minor-radio-padding" value="2" name="gwimVoteForCandidate">N/A
          </mat-radio-button>
        </mat-radio-group>
        <mat-error *ngIf="submit.value && gwimVoteForCandidate.hasError('required') || checkRadioTwo"
          class="padding-top">Please select if a
          contribution was to a candidate or party committee, were you entitled to vote for the candidate or in the
          jurisdiction covered by the party committee</mat-error>
      </div>

      <div>
        <mat-form-field class="max-zoom width350-marginbottom-margintop">
          <mat-label>Please enter job title</mat-label>
          <input matInput placeholder="Position" formControlName="pcPosition" maxlength="250">
          <mat-error>Please enter a valid job title</mat-error>
        </mat-form-field>
      </div>

      <p class="bofa--heading is-8">By signing below you acknowledge that you have fully reviewed and completed
        the information above</p>

      <div class="width-750-margintop-marginbottom" *ngIf="pcSurveyData">
        <app-wet-signature formControlName="pcGwimSignature" [signatureImg]="signatureImg" (sigURL)="getUrl($event)" (sigCheck)="sigCheck($event)">
        </app-wet-signature>
        <mat-error *ngIf="pcGwimSignature.hasError('invalid') || sigCheckValue"> Please enter electronic
          signature </mat-error>
      </div>

      <mat-checkbox aria-required="true" required formControlName="pcGwimAccepted" class="minor-check-padding"
        (focusout)="confirmOnBlur()" (focusin)="confirmOnFocus()">
        <mat-label class="whitespace-normal"><abbr title="required">* </abbr>Yes, I agree that I have fully
          reviewed and completed the information above
        </mat-label>
      </mat-checkbox>
      <mat-error class="whitespace-normal" *ngIf="pcGwimAccepted.hasError('invalid') && check"> Please check
        the box to agree to the above language </mat-error>

      <div>
        <mat-form-field class="max-zoom width350-marginbottom-margintop" hideRequiredMarker>
          <mat-label><abbr title="required">* </abbr>Please enter your full name</mat-label>
          <input matInput placeholder="Full name" formControlName="pcGwimSignedName" required maxlength="250">
          <mat-error>Please enter your full name</mat-error>
        </mat-form-field>
      </div>

      <div>
        <mat-form-field class="max-zoom width-350">
          <mat-label>Date Signed</mat-label>
          <input value="{{ date }}" matInput disabled>
        </mat-form-field>
      </div>
    </div>
    <p *ngIf="contribution.value != 1">
      * A “Political Contribution” includes any gift, subscription, loan, advance, or deposit of money or any thing of
      value made for
      the purpose of influencing any election for federal, state, or local office; for payment or reduction of debt
      incurred in connection with any such election; or for transition or inaugural expenses for a successful candidate.
      These include
      contributions made to candidates for elected office, political parties, political action committees, and any other
      entities
      organized under Section 527 of the Internal Revenue Code.
    </p>
  </form>
</div>